export enum Colors {
    STREAK_FIRE_COLOR = '#fe872c',
}
